import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';
import { useNavigate, useParams } from 'react-router-dom';
import { PqrFilter } from '../../../../../shared/types/modules/pqr';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import { ALERTS_NEW } from '../../../../../routes/paths';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import Swal from 'sweetalert2';
import variables from '../../../../../shared/styles/settings.module.scss';
import { useAuthContext } from '../../../../../contexts/authContext';

export const usePqrFilters = (
    onFilter?: (data: PqrFilter) => void,
    selectionModel?: GridRowSelectionModel
) => {
    const { pqrId } = useParams();
    const { modeTheme } = useAuthContext();
    const [receptionChannels, setReceptionChannels] = useState<ISelect[]>([]);
    const [halfs, setHalfs] = useState<ISelect[]>([]);
    const [types, setTypes] = useState<ISelect[]>([]);
    const [processingAreas, setProcessingAreas] = useState<ISelect[]>([]);
    const [incharges, setIncharges] = useState<ISelect[]>([]);
    const [status, setStatus] = useState<ISelect[]>([]);
    const [reconsiderations, setReconsiderations] = useState<ISelect[]>([]);
    const [typesMotives, setTypeMotive] = useState<ISelect[]>([]);

    const navigate = useNavigate();

    const onSubmit = (data: PqrFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            pqrId: pqrId?.trim() || '',
        },
        onSubmit,
    });

    useEffect(() => {
        if (formik?.values?.pqrId && formik?.values?.pqrId === pqrId?.trim()) {
            formik?.submitForm();
        }
    }, [pqrId, formik?.values?.pqrId]);

    useEffect(() => {
        if (formik?.values?.startCreatedAt) {
            formik?.setFieldValue('endCreatedAt', undefined);
        }
    }, [formik?.values?.startCreatedAt]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_RECEPTION_CHANNEL).then((params) =>
            setReceptionChannels(params)
        );
        asyncGetLabelParams(ParamEnum.PQR_HALF).then((params) =>
            setHalfs(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) => setTypes(params));
        asyncGetParams(ParamEnum.PQR_BRANCH).then((params) =>
            setProcessingAreas(params)
        );
        asyncGetParams(ParamEnum.PQR_REDIRECTION_AREA).then((params) =>
            setIncharges(params)
        );
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setStatus(params)
        );
        asyncGetParams(ParamEnum.PQR_REPLICA).then((params) =>
            setReconsiderations(params)
        );
        asyncGetLabelParams(ParamEnum.TYPE_MOTIVE).then((items) =>
            setTypeMotive(items)
        );
    }, []);

    const onHandleClick = () => {
        if (selectionModel && selectionModel?.length > 0) {
            Swal.fire({
                title: 'Generar alerta individual',
                html:
                    'Se generarán las alertas con relación a las PQRs seleccionadas, si las mismas poseen alertas.<br>' +
                    '¿Está Seguro(a) que desea continuar?',
                icon: 'question',
                iconColor:
                    modeTheme === 'darkMode'
                        ? variables.darkColor
                        : variables.primaryColor,
                showDenyButton: true,
                denyButtonText: 'CANCELAR',
                denyButtonColor:
                    modeTheme === 'darkMode'
                        ? variables.darkColor
                        : variables.primaryColor,
                confirmButtonText: 'ACEPTAR',
                confirmButtonColor:
                    modeTheme === 'darkMode'
                        ? variables.darkColor
                        : variables.primaryColor,
                customClass: 'swal-wide-class',
            }).then((response) => {
                if (response.isConfirmed) {
                    navigate(`${ALERTS_NEW}/${selectionModel?.join(',')}`);
                }
            });
        } else {
            ToastSwal.fire({
                text: 'Debe seleccionar al menos una PQR',
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }
    };

    return {
        formik,
        receptionChannels,
        halfs,
        types,
        processingAreas,
        incharges,
        status,
        reconsiderations,
        typesMotives,
        onHandleClick,
    };
};
